import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { CommonUtil, LoginService } from '@serengeti/serengeti-common';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { environment } from 'src/environments/environment';
import { GuestUserService } from "@serengeti/serengeti-user";

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit, AfterViewInit, OnDestroy {

    loginName: string = null;
    loginId: string = null;

    returnUrl: string;
    routeSubscription: Subscription;

    profile = environment.profile;
    keycloakEndPoint: string;

    submenuActivate: boolean = false;
    submenuDisplay: boolean = false;
    selectedSubmenu = '';
    isKeycloakUsed: boolean;

    constructor(private loginService: LoginService,
        private translateService: TranslateService,
        private router: Router,
        private activedRouter: ActivatedRoute,
        private titleService: Title,
        private guestUserService: GuestUserService) {
        this.keycloakEndPoint = environment.serviceKeycloakEndPoint;
        this.isKeycloakUsed = localStorage.getItem("isKeycloakUsed") === "true";

        this.routeSubscription = this.router.events.subscribe((event: NavigationEnd) => {
            if (event instanceof NavigationEnd) {
                this.translateService.get('home.title.' + environment.profile).subscribe((title: string) => {
                    this.titleService.setTitle(title);
                });

                const homeUrl = this.router.parseUrl(event.url);

                if (homeUrl.root.children['primary'] && homeUrl.root.children['primary'].segments[0].path == 'activate') {
                    const id = homeUrl.queryParams['userId'];
                    const key = homeUrl.queryParams['authKey'];
                    this.guestUserService.activate(id, key).subscribe(result => {
                        if (result == true) {
                            this.translateService.get('home.activation.successed').subscribe((message: string) => {
                                alert(message);
                            });
                            this.router.navigate(['/member/login']);
                        }
                        else {
                            this.translateService.get('home.activation.failed').subscribe((message: string) => {
                                alert(message);
                            });
                        }
                        this.router.navigate(['/home']);
                    });
                }
            }
        });
    }

    ngOnInit() {}

    ngAfterViewInit() {
        const session = this.loginService.loadLoginSession();

        if (session) {
            this.loginId = session.loginId;
            this.loginName = session.loginName;
        }

        this.isKeycloakUsed = localStorage.getItem("isKeycloakUsed") === "true";
    }

    ngOnDestroy() {
        if (this.routeSubscription) {
            this.routeSubscription.unsubscribe();
        }
    }

    showSubmenu() {
        this.submenuDisplay = !this.submenuDisplay;
    }

    goMain() {
        if (this.loginName) {
            this.router.navigate(['/main']);
        } else {
            this.translateService.get('common.invalid.access-user').subscribe((message: string) => {
                alert(message);
            });
        }
    }

    goHome() {
        this.submenuActivate = false;
    }

    goSubmenu(submenu) {
        this.submenuActivate = true;

        this.selectedSubmenu = submenu;
    }

    public ssoLogin() {
        const redirectUri = `${window.location.protocol}//${window.location.host}/ssosignin`;
        window.location.href = CommonUtil.buildEndPoint(this.keycloakEndPoint, "user/auth") + "?redirect_uri=" + encodeURIComponent(redirectUri);
    }
}
